import { API_HOST, apiEndpoints } from '../../constants/APIConstants';
import AuthService from '../AuthService';
import APIService from '../APIService';

export function upload(file) {
  return new Promise((resolve, reject) => {
    if (!file) reject(new Error('Cannot upload empty file'));
    else {
      const formData = new FormData();
      formData.append('file', file, file.name || 'image.png');
      APIService.fetchWithTimeout(
        `${API_HOST}${apiEndpoints.UPLOAD}`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${AuthService.getAuthToken()}`,
          },
          body: formData,
        },
        (error, data) => {
          if (error) reject(error);
          else resolve(data);
        }
      );
    }
  });
}
export default {};
